import React from "react";
import { Container, Grid, Box, Typography } from "@mui/material";
import ContactFrom from "./index";
import UniformCard from "../../components/UniformCard/UniformCard";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import PageTitle from "../../components/pagetitle/PageTitle";

const Contactpage = () => {
  const themeColors = {
    primary: "var(--primary-color)",
    secondary: "var(--secondary-color)",
    textGray: "#687693",
    lightBg: "#f8fbff",
    white: "#fff"
  };

  return (
    <Box sx={{ bgcolor: themeColors.lightBg }}>
      {/* Hero Section */}
      <PageTitle 
        pageTitle="Get In Touch" 
        pagesub="Have a question or need assistance? Reach out to our dedicated team of professionals today." 
      />

      {/* Main Content */}
      <Container sx={{ position: 'relative', zIndex: 2, pb: 10, mt: 5 }}>
        <Grid container spacing={4}>
          {/* Left Side: Contact Info */}
          <Grid item xs={12} lg={4}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <UniformCard
                icon={<FaMapMarkerAlt size={30} />}
                title="Regd. Office"
                description="A4-403, IREO Skyon, Sector 60, Gurugram, Haryana-122011"
                centered={false}
              />
              <UniformCard
                icon={<FaMapMarkerAlt size={30} />}
                title="Communication Address"
                description="4th Floor, 404, Paras Trinity, Sector 63, Gurugram, Haryana-122011"
                centered={false}
              />
              <UniformCard
                icon={<FaEnvelope size={30} />}
                title="Email Address"
                description="admin@vdoogar.com"
                centered={false}
              />
              <UniformCard
                icon={<FaPhoneAlt size={30} />}
                title="Phone Number"
                description="+91 99996 32411"
                centered={false}
              />
            </Box>
          </Grid>

          {/* Right Side: Form */}
          <Grid item xs={12} lg={8}>
            <Box sx={{ 
              bgcolor: themeColors.white, 
              p: { xs: 4, md: 6 }, 
              borderRadius: '16px',
              borderTop: `6px solid ${themeColors.primary}`,
              boxShadow: '0 20px 50px rgba(0,0,0,0.08)'
            }}>
              <Box sx={{ mb: 5 }}>
                <Typography variant="h4" sx={{ 
                  fontFamily: "'Roboto Slab', serif", 
                  color: themeColors.primary,
                  fontWeight: 700,
                  mb: 1
                }}>
                  Send Us A Message
                </Typography>
                <Typography sx={{ color: themeColors.textGray }}>
                  Fill out the form below and we will get back to you within 24 hours.
                </Typography>
              </Box>
              <ContactFrom />
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* Map Section */}
      <Box sx={{ width: '100%', height: '450px', mt: 5 }}>
        <iframe
          title="vdoogar-location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d888.8249971700577!2d77.09097315209641!3d28.4010853!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d223b06543d41%3A0x13605e6ad66428d9!2sParas%20Trinity!5e1!3m2!1sen!2sin!4v1758090881427!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0, grayscale: '1', filter: 'contrast(1.1)' }}
          allowFullScreen=""
          loading="lazy"
        />
      </Box>
    </Box>
  );
};

export default Contactpage;
